import(/* webpackMode: "eager", webpackExports: ["PortraitCard"] */ "/vercel/path0/src/components/carousel/portraitsCarousel.tsx");
